import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
import qs from 'qs' // 全局加载,必须应用
import { Lazyload } from 'vant'
import waterfall from 'vue-waterfall2' // 引入

Vue.prototype.qs = qs
Vue.use(Lazyload, {
  preLoad: 1.3,
  attempt: 3,
  lazyComponent: true
})
Vue.config.productionTip = false
Vue.use(waterfall)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
